module.exports = __webpack_public_path__ + "img/phone.03cd92ab.svg";